define('PDPSchema.ProductDetails.Full.View', [
	'ProductDetails.Full.View',
	'SC.Configuration'
], function (
	ProductDetailsFullView,
	Configuration
) {
	'use strict';

	ProductDetailsFullView.prototype.getJsonLd = _.wrap(ProductDetailsFullView.prototype.getJsonLd, function (fn) {
	
        var jsonLdPromise = fn.apply(this, _.toArray(arguments).slice(1));
        var self = this;
    
        if (Configuration.get('structureddatamarkup.type') !== 'JSON-LD') {
            return jQuery.Deferred().resolve(null);
        }
    
        var modelItem = this.model.get('item');
        var offers = [];
        if (this.model.isMatrixItem()) {
            /*
             * Fetch item options and construct a unique matrix child item URL that contains the
             * item option names and values
             */
            var itemOptions = this.model.getVisibleOptions();
    
            var childItems = this.model.getSelectedMatrixChilds([]);
            _.each(childItems, function (childItem) {
                var itemOptionParameters = {};
                _.each(itemOptions, function(itemOption) {
                    var itemValue = childItem.get(itemOption.get('itemOptionId'));
                    if(itemValue) {
                        var itemOptionValue = _.find(itemOption.get('values'), function(value) {
                            return value.label === itemValue;
                        });
                        itemOptionParameters[itemOption.get('urlParameterName')] = itemOptionValue.internalid;
                    }
                });
    
                var itemUrl = self.model.generateURL(itemOptionParameters);
                itemUrl = itemUrl.replace(/\?quantity=1&/g, '?');
                itemUrl = itemUrl.replace(/\?quantity=1$/g, '');
    
                offers.push(childItem.getJsonLdOffer(itemUrl));
            });
        } else {
            offers.push(this.model.get('item').getJsonLdOffer());
        }
    
        var brand = {
            '@type': 'Brand',
            name: modelItem.get('_brand')
        };
    
        var storeDetailedDescription = this.model.buildItemSeoDescription(modelItem.getStoreDescriptionAsText()) || '';
        return jsonLdPromise.then(function (jsonLd) {
            return _.extend({}, jsonLd, {
                '@type': 'Product',
                name: self.page_header,
                brand: brand,
                image: self.model.getImages()[0].url.toString(),
                offers: offers,
                description: storeDetailedDescription.length > 0 ? storeDetailedDescription : undefined,
                sku: self.model.get('item').getSku() || undefined
            });
        });
    });

});
